export class Attachment {
  constructor({ bucket = null, path = null, fileName = null }) {
    this.bucket = bucket;
    this.path = path;
    this.fileName = fileName;
  }
}
